// Foamcore PVC-D Pipe - Strong and Lightweight Drainage System Catalog
// HSN CODE: 39172390

export const foamcoreCatalog = {
    page: 1,
    title: "ASTRAL FOAMCORE PVC-D PIPE - STRONG AND LIGHTWEIGHT DRAINAGE SYSTEM",
    hsn_code: "39172390",
    description: "Strong and lightweight PVC-D drainage pipes - IS:16098 (PT-1) certified",
    certification: "IS:16098 (PT-1)",
    features: [
        "IS:16098 (PT-1) Certified",
        "Strong and lightweight",
        "Selfit and Ringfit systems",
        "Multiple stiffness classes (SN2, SN4, SN8)",
        "PVC-D technology"
    ],
    sections: [
        {
            name: "SELFIT PIPES - SN 2",
            fitting_type: "SELFIT",
            stiffness_class: "SN 2",
            items: [
                { size_mm: "160", length_socket: "3 M S/S", product_code: "M131020312", std_pkg: 1, price_inr_per_pc: 2376.00 },
                { size_mm: "160", length_socket: "6 M S/S", product_code: "M131020612", std_pkg: 1, price_inr_per_pc: 4662.00 },
                { size_mm: "200", length_socket: "3 M S/S", product_code: "M131020314", std_pkg: 1, price_inr_per_pc: 3492.00 },
                { size_mm: "200", length_socket: "6 M S/S", product_code: "M131020614", std_pkg: 1, price_inr_per_pc: 6858.00 },
                { size_mm: "250", length_socket: "3 M S/S", product_code: "M131020316", std_pkg: 1, price_inr_per_pc: 5424.00 },
                { size_mm: "250", length_socket: "6 M S/S", product_code: "M131020616", std_pkg: 1, price_inr_per_pc: 10830.00 },
                { size_mm: "315", length_socket: "3 M S/S", product_code: "M131020318", std_pkg: 1, price_inr_per_pc: 8526.00 },
                { size_mm: "315", length_socket: "6 M S/S", product_code: "M131020618", std_pkg: 1, price_inr_per_pc: 17058.00 }
            ]
        },
        {
            name: "SELFIT PIPES - SN 4",
            fitting_type: "SELFIT",
            stiffness_class: "SN 4",
            items: [
                { size_mm: "110", length_socket: "3 M S/S", product_code: "M131040309", std_pkg: 1, price_inr_per_pc: 1356.00 },
                { size_mm: "110", length_socket: "6 M S/S", product_code: "M131040609", std_pkg: 1, price_inr_per_pc: 2792.00 },
                { size_mm: "160", length_socket: "3 M S/S", product_code: "M131040312", std_pkg: 1, price_inr_per_pc: 2793.00 },
                { size_mm: "160", length_socket: "6 M S/S", product_code: "M131040612", std_pkg: 1, price_inr_per_pc: 5592.00 },
                { size_mm: "200", length_socket: "3 M S/S", product_code: "M131040314", std_pkg: 1, price_inr_per_pc: 4254.00 },
                { size_mm: "200", length_socket: "6 M S/S", product_code: "M131040614", std_pkg: 1, price_inr_per_pc: 8502.00 },
                { size_mm: "250", length_socket: "6 M D/S", product_code: "M131040614", std_pkg: 1, price_inr_per_pc: 8516.00 },
                { size_mm: "250", length_socket: "3 M S/S", product_code: "M131040316", std_pkg: 1, price_inr_per_pc: 6828.00 },
                { size_mm: "250", length_socket: "6 M S/S", product_code: "M131040616", std_pkg: 1, price_inr_per_pc: 13650.00 },
                { size_mm: "250", length_socket: "3 M D/S", product_code: "M131040316", std_pkg: 1, price_inr_per_pc: 6873.00 },
                { size_mm: "315", length_socket: "3 M S/S", product_code: "M131040318", std_pkg: 1, price_inr_per_pc: 10539.00 },
                { size_mm: "315", length_socket: "6 M S/S", product_code: "M131040618", std_pkg: 1, price_inr_per_pc: 21078.00 }
            ]
        },
        {
            name: "RINGFIT PIPES - SN 4",
            fitting_type: "RINGFIT",
            stiffness_class: "SN 4",
            items: [
                { size_mm: "110", length_socket: "3 M S/S", product_code: "M121040309", std_pkg: 1, price_inr_per_pc: 1383.00 },
                { size_mm: "110", length_socket: "6 M S/S", product_code: "M121040609", std_pkg: 1, price_inr_per_pc: 2742.00 },
                { size_mm: "160", length_socket: "3 M S/S", product_code: "M121040312", std_pkg: 1, price_inr_per_pc: 2853.00 },
                { size_mm: "160", length_socket: "6 M S/S", product_code: "M121040612", std_pkg: 1, price_inr_per_pc: 5652.00 }
            ]
        },
        {
            name: "RINGFIT PIPES - SN 8",
            fitting_type: "RINGFIT",
            stiffness_class: "SN 8",
            items: [
                { size_mm: "110", length_socket: "3 M S/S", product_code: "M121080309", std_pkg: 1, price_inr_per_pc: 1713.00 },
                { size_mm: "110", length_socket: "6 M S/S", product_code: "M121080609", std_pkg: 1, price_inr_per_pc: 3378.00 },
                { size_mm: "160", length_socket: "3 M D/S", product_code: "M4461080312", std_pkg: 1, price_inr_per_pc: 3498.00 },
                { size_mm: "160", length_socket: "6 M S/S", product_code: "M121080612", std_pkg: 1, price_inr_per_pc: 6606.00 }
            ]
        },
        {
            name: "SELFIT PIPES - SN 8",
            fitting_type: "SELFIT",
            stiffness_class: "SN 8",
            items: [
                { size_mm: "110", length_socket: "3 M S/S", product_code: "M131080309", std_pkg: 1, price_inr_per_pc: 1671.00 },
                { size_mm: "110", length_socket: "6 M S/S", product_code: "M131080609", std_pkg: 1, price_inr_per_pc: 3294.00 },
                { size_mm: "160", length_socket: "3 M S/S", product_code: "M131080312", std_pkg: 1, price_inr_per_pc: 3306.00 },
                { size_mm: "160", length_socket: "6 M S/S", product_code: "M131080612", std_pkg: 1, price_inr_per_pc: 6498.00 },
                { size_mm: "160", length_socket: "6 M D/S", product_code: "M121080612", std_pkg: 1, price_inr_per_pc: 6726.00 },
                { size_mm: "200", length_socket: "3 M S/S", product_code: "M131080314", std_pkg: 1, price_inr_per_pc: 5196.00 },
                { size_mm: "200", length_socket: "6 M S/S", product_code: "M131080614", std_pkg: 1, price_inr_per_pc: 10212.00 },
                { size_mm: "250", length_socket: "3 M S/S", product_code: "M131080316", std_pkg: 1, price_inr_per_pc: 8181.00 },
                { size_mm: "250", length_socket: "6 M S/S", product_code: "M131080616", std_pkg: 1, price_inr_per_pc: 16032.00 },
                { size_mm: "315", length_socket: "3 M S/S", product_code: "M131080318", std_pkg: 1, price_inr_per_pc: 12795.00 },
                { size_mm: "315", length_socket: "6 M S/S", product_code: "M131080618", std_pkg: 1, price_inr_per_pc: 25062.00 }
            ]
        }
    ]
};

// Helper functions
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};

export const getAllFoamcoreProducts = () => {
    const allProducts = [];
    foamcoreCatalog.sections.forEach((section, sectionIndex) => {
        section.items.forEach((item, itemIndex) => {
            allProducts.push({
                id: `foamcore-${sectionIndex}-${itemIndex}`,
                ...item,
                sectionName: section.name,
                fittingType: section.fitting_type,
                stiffnessClass: section.stiffness_class,
                hsnCode: foamcoreCatalog.hsn_code
            });
        });
    });
    return allProducts;
};

export const getFoamcoreSizes = () => {
    const allProducts = getAllFoamcoreProducts();
    return [...new Set(allProducts.map(p => p.size_mm))].sort((a, b) => parseInt(a) - parseInt(b));
};

export const getFoamcoreFittingTypes = () => {
    return [...new Set(foamcoreCatalog.sections.map(s => s.fitting_type))];
};

export const getFoamcoreStiffnessClasses = () => {
    return [...new Set(foamcoreCatalog.sections.map(s => s.stiffness_class))];
};
